import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// Thunk pour récupérer les cartes de paiement
export const fetchMyCards = createAsyncThunk(
  "payment/fetchMyCards",
  async (_, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        return rejectWithValue({ message: "Token manquant" });
      }

      const apiUrl = `${process.env.REACT_APP_API_URL}payment-methods`;
      const response = await axios.get(apiUrl, {
        headers: { Authorization: `Bearer ${token}` },
      });

      return response.data.cards; // Tableau de cartes
    } catch (error) {
      // console.error("fetchMyCards API Error:", error);
      return rejectWithValue({
        message: error.message,
        status: error.response?.status,
        data: error.response?.data,
      });
    }
  }
);
//api/prestataire/transferts
export const fetchMyTransfers = createAsyncThunk(
  "payment/fetchMyTransfers",
  async (_, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        return rejectWithValue({ message: "Token manquant" });
      }

      const apiUrl = `${process.env.REACT_APP_API_URL}prestataire/transferts`;
      const response = await axios.get(apiUrl, {
        headers: { Authorization: `Bearer ${token}` },
      });
      // console.log(response?.data.data);
      return response.data.data; // Tableau de cartes
    } catch (error) {
      // console.error("fetchMyCards API Error:", error);
      return rejectWithValue({
        message: error.message,
        status: error.response?.status,
        data: error.response?.data,
      });
    }
  }
);

// Thunk pour supprimer une carte de paiement
export const deletePaymentCard = createAsyncThunk(
  "payment/deletePaymentCard",
  async (payment_method_id, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        return rejectWithValue({ message: "Token manquant" });
      }

      const apiUrl = `${process.env.REACT_APP_API_URL}payment-methods/${payment_method_id}`;
      await axios.delete(apiUrl, {
        headers: { Authorization: `Bearer ${token}` },
        data: { payment_method_id },
      });

      return payment_method_id;
    } catch (error) {
      // console.error("deletePaymentCard API Error:", error);
      return rejectWithValue({
        message: error.message,
        status: error.response?.status,
        data: error.response?.data,
      });
    }
  }
);

// Thunk pour choisir  une carte de paiement par défaut
export const defaultPaymentCard = createAsyncThunk(
  "payment-methods/set-default",
  async (payment_method_id, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      // console.log("token",token)
      if (!token) {
        return rejectWithValue({ message: "Token manquant" });
      }

      const apiUrl = `${process.env.REACT_APP_API_URL}payment-methods/${payment_method_id}/set-default`;
      await axios.post(apiUrl,
        { payment_method_id: payment_method_id },
        {
          headers: { Authorization: `Bearer ${token}` },
        });

      return payment_method_id;
    } catch (error) {
      // console.error("defaultPaymentCard API Error:", error);
      return rejectWithValue({
        message: error.message,
        status: error.response?.status,
        data: error.response?.data,
      });
    }
  }
);

const methodePaymentSlice = createSlice({
  name: "payment",
  initialState: {
    cards: [],
    status: "idle",
    error: null,

    transfers: [],
    transfersStatus: "idle",
    transfersError: null,
  },
  reducers: {
    clearCards: (state) => {
      state.cards = [];
      state.status = "idle";
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // fetchMyCards
      .addCase(fetchMyCards.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchMyCards.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.cards = Array.isArray(action.payload) ? action.payload : [];
      })
      .addCase(fetchMyCards.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || "Erreur inconnue";
      })
      //fetch my transfers
      .addCase(fetchMyTransfers.pending, (state) => {
        state.transfersStatus = "loading";
        state.transfersError = null;
      })
      .addCase(fetchMyTransfers.fulfilled, (state, action) => {
        state.transfersStatus = "succeeded";
        state.transfers = Array.isArray(action.payload) ? action.payload : [];
      })
      .addCase(fetchMyTransfers.rejected, (state, action) => {
        state.transfersStatus = "failed";
        state.transfersError = action.payload || "Erreur inconnue";
      })

      // deletePaymentCard
      .addCase(deletePaymentCard.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(deletePaymentCard.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.cards = state.cards.filter((card) => card.id !== action.payload);
      })
      .addCase(deletePaymentCard.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || "Erreur inconnue";
      })
      // defaultPaymentCard
      .addCase(defaultPaymentCard.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(defaultPaymentCard.fulfilled, (state, action) => {
        state.status = "succeeded";
        // Met à jour la carte par défaut dans la liste des cartes
        state.cards = state.cards.map((card) => ({
          ...card,
          is_default: card.id === action.payload,
        }));
      })
      .addCase(defaultPaymentCard.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || "Erreur inconnue";
      });
  },
});

// Export actions et sélecteurs
export const { clearCards } = methodePaymentSlice.actions;
export const selectPaymentCards = (state) => state.payment.cards;
export const selectPaymentStatus = (state) => state.payment.status;
export const selectPaymentError = (state) => state.payment.error;

export default methodePaymentSlice.reducer;
